const controller = "rates";

export default {
  controller,
  history: (rateId: number) => controller + `/${rateId}/history`,
};
